const routes = [
    //{
    //    path: '/leads/available_leads',
    //   name: 'AvailableLeads',
    //    component: () => import( /* webpackChunkName: "leads" */ '../views/Leads/AvailableLeads.vue')
    //},
    {
        path: '/leads',
        name: 'Leads',
        component: () => import( /* webpackChunkName: "leads" */ '../views/Leads/Leads.vue')
    },
    {
        path: '/leads/dx-lead-orders',
        name: 'My DX Lead Orders',
        component: () => import( /* webpackChunkName: "leads" */ '../views/LeadOrders/DxLeadOrders/AgentDxLeadOrders.vue')
    },
    {
        path: '/leads/dx-lead-orders-by-state',
        name: 'DX Lead Orders by State',
        component: () => import( /* webpackChunkName: "leads" */ '../views/LeadOrders/DxLeadOrders/DxLeadOrdersByState.vue')
    },
    {
        path: '/leads/dx-allocate-leads',
        name: 'Allocate DX Leads',
        component: () => import( /* webpackChunkName: "leads" */ '../views/LeadOrders/DxLeadOrders/AllocateDXLeads.vue')
    },
    {
        path: '/leads/recruiting-lead-orders',
        name: 'Recruiting Lead Orders',
        component: () => import( /* webpackChunkName: "leads" */ '../views/LeadOrders/Recruiting/AgentRecruitingLeadOrders.vue')
    },
    {
        path: '/leads/quility-digital-lead-orders',
        name: 'Quility Digital Lead Orders',
        component: () => import( /* webpackChunkName: "leads" */ '../views/LeadOrders/QuilityDigitalLeads/AgentDigitalLeadOrders.vue')
    },
    {
        path: '/leads/approve-digital-lead-orders',
        name: 'Approve Digital Lead Orders',
        component: () => import( /* webpackChunkName: "leads" */ '../views/LeadOrders/QuilityDigitalLeads/ApproveDigitalLeadOrders.vue')
    },
]

export default routes